import {SnackBarActions} from '@store/aviary/aviary.adapter';
import {
  CUSTOM_ERROR_HANDLERS_CREATOR,
  CustomErrorHandlersCreator,
  REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE
} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';

export function contextWithErrorHandlerForGetAuthBranch(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // requested branch id not found in database
          errorCodes: 'ENTITY_ID_NOT_FOUND',
          actions: SnackBarActions.showError(`Branch information not found. ${REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE}`)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
